module.exports = __webpack_public_path__ + "img/xx-icon.5398c094.png";